var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _rect3, _circle, _path17, _circle2, _path18, _circle3, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeepOceanThumbnailGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#67717E",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6359 53.5418C21.0557 55.503 23.6595 66.7355 23.4967 68.1618L38.957 61.7433C35.3767 58.3557 27.5001 51.9728 24.6359 53.5418Z",
    fill: "#D5D8DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6359 95.359C21.0557 93.3977 23.6595 82.1653 23.4967 80.7389L38.957 87.1575C35.3767 90.5451 27.5001 96.9279 24.6359 95.359Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7039 75.022C14.4796 71.8614 12.7657 64.9872 15.7039 62.7748C18.642 60.5623 16.9281 70.0178 15.7039 75.022Z",
    fill: "#D5D8DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7039 75.022C14.4796 77.8952 12.7657 84.1446 15.7039 86.1559C18.642 88.1672 16.9281 79.5713 15.7039 75.022Z",
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6188 57.8619C91.9225 59.9733 92.9997 65.5544 92.9997 73.8787L92.9999 74.3701C93.0049 86.4019 93.008 93.8879 65.4548 93.8879C38.4202 93.8879 19.1157 84.8041 17.9102 75.7341H17.0878C17.031 76.29 16.8938 76.8592 16.6378 77.4006C15.5465 79.7081 13 76.2469 13 75.0931C13 73.9394 16.2973 71.3755 16.6378 72.5293C16.7916 72.8907 16.9715 73.4876 17.0619 74.1958H17.8751C18.4277 67.0846 28.2415 61.9727 46.5018 59.1024C47.1771 56.8266 48.2787 53.6091 50.1213 52.2541C52.4867 50.5144 64.011 46.9305 69.3801 45.8822C68.9763 41.1087 69.1831 33.3329 71.5842 30.7176C74.894 27.1125 78.6187 27.074 81.1799 27.0475C81.7151 27.0419 82.1996 27.0369 82.6188 27C82.8964 27.4535 82.8274 28.2301 82.7364 29.2548C82.6816 29.8716 82.6188 30.5784 82.6188 31.3586C82.6188 31.7696 82.0187 31.7088 81.109 31.6167C79.465 31.4502 76.8098 31.1814 74.8582 33.4097C72.7609 35.8043 72.2053 41.727 72.2503 45.6063C75.7214 45.786 82.6188 47.3373 82.6188 52.2541V57.8619Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1341 50.1519C82.1844 45.7846 75.9794 44.3932 72.2638 44.0314C72.248 44.5823 72.2439 45.1114 72.2496 45.6071C75.1674 45.7582 80.5061 46.8784 82.1341 50.1519ZM69.2618 44.0168C65.0154 44.6503 52.4489 48.2545 51.4547 49.3055C50.9373 49.8525 50.9054 50.8166 51.041 51.7071C54.6409 49.8509 64.5255 46.8308 69.3795 45.883C69.3302 45.3007 69.29 44.6737 69.2618 44.0168Z",
    fill: "#D5D8DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3037 59.3039C47.6319 58.4835 71.3821 58.0332 82.6188 57.7768C81.2041 56.9649 75.7798 55.3668 65.4 55.4693C52.4252 55.5975 51.5066 50.4982 49.4452 52.6775C47.7961 54.4209 45.8292 57.4665 45.3037 59.3039Z",
    fill: "#9DA4AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6161 32.7687C72.3849 36.0505 71.9888 42.7678 72.0696 45.7162C71.3421 41.3577 72.0696 32.7687 74.6161 30.4612C76.6532 28.6152 80.4769 29.0083 82.1341 29.4357V31.4868C80.5577 30.5467 76.8472 29.487 74.6161 32.7687Z",
    fill: "#9DA4AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1031 73.7993C80.2061 76.0861 79.1972 75.5939 18.7981 76.1656C21.283 84.5673 36.6067 90.3654 56.0718 92.4362C88.518 94.7229 90.4465 87.0522 92.1031 81.6682C92.1031 80.4897 92.1031 75.0418 92.1031 73.7993Z",
    fill: "#9DA4AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7854 76.1656C16.3132 79.1833 13 76.7373 13 75.0222C13.7842 75.0977 16.0114 76.0938 16.7854 76.1656Z",
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.4149,
    ry: 14.931,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2791 75.6668)",
    fill: "#D5D8DD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.17309,
    ry: 9.50153,
    transform: "matrix(0.894018 0.448031 -0.409149 0.912468 62.2792 75.6669)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5394 75.4496C76.5664 77.4294 76.2243 79.3954 75.5325 81.2354C74.8408 83.0754 73.8131 84.7533 72.5079 86.1734C71.2028 87.5934 69.6459 88.7279 67.9261 89.5118C66.2063 90.2958 64.3573 90.714 62.4846 90.7425C60.6119 90.771 58.7522 90.4093 57.0117 89.6781C55.2713 88.9468 53.6841 87.8603 52.3408 86.4805C50.9976 85.1008 49.9245 83.4548 49.1829 81.6367C48.4414 79.8185 48.0458 77.8638 48.0188 75.884L62.2791 75.6668L76.5394 75.4496Z",
    fill: "#67717E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3542 75.5512C71.3832 78.0957 70.4549 80.5481 68.7736 82.369C67.0922 84.1899 64.7954 85.2301 62.3886 85.2608C59.9818 85.2915 57.662 84.3101 55.9396 82.5326C54.2171 80.7551 53.2332 78.327 53.2042 75.7826L62.2792 75.6669L71.3542 75.5512Z",
    fill: "#B9BEC6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2329 91.6077C39.1586 80.9421 41.5353 64.5039 43.2329 59.718L40.3338 60.1322C37.3266 70.4902 38.5454 86.0363 39.9197 90.7794L43.2329 91.6077Z",
    fill: "#D5D8DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6484 91.6079C80.8631 79.6023 83.9507 64.4449 85.8908 58.8898L83.406 58.0615C79.1376 70.3681 79.4597 81.0023 82.1635 92.4362L84.6484 91.6079Z",
    fill: "#D5D8DD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3193 66.7685C91.3196 65.2149 88.9008 62.5798 87.6913 61.4564C86.0205 61.0783 86.3334 63.0913 87.221 63.5349C88.1086 63.9785 88.7086 66.1778 88.9955 67.8207C89.2824 69.4636 91.3189 68.7106 91.3193 66.7685Z",
    fill: "#D5D8DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7881 52.4507C80.4001 50.8098 77.0695 48.6049 75.4527 47.7075C73.5126 47.7075 74.3614 49.7586 75.4527 50.015C76.5441 50.2714 77.7567 52.4507 78.4842 54.1172C79.2118 55.7837 81.2732 54.5018 80.7881 52.4507Z",
    fill: "#D5D8DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5708,
    y: 72.7354,
    width: 15.1416,
    height: 5.71691,
    rx: 2.85846,
    fill: "#D5D8DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.25,
    cy: 31.5,
    r: 6.75,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9693 31.4089C47.9847 32.7609 47.6751 30.4663 46.0786 29.3034C44.482 28.1406 42.2031 28.5499 43.1878 27.1979C44.1725 25.846 46.265 25.6927 47.8615 26.8555C49.458 28.0183 49.954 30.057 48.9693 31.4089Z",
    fill: "#9DA4AF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.375,
    cy: 10.875,
    r: 4.875,
    transform: "rotate(-90 24.375 10.875)",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3092 7.46658C25.2856 8.17775 23.6284 8.40132 22.7886 9.55438C21.9488 10.7074 22.2444 12.3533 21.268 11.6422C20.2915 10.931 20.1808 9.41976 21.0206 8.2667C21.8605 7.11364 23.3328 6.75542 24.3092 7.46658Z",
    fill: "#9DA4AF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.875,
    cy: 39.375,
    r: 4.875,
    transform: "rotate(-90 16.875 39.375)",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8092 35.9666C17.7856 36.6778 16.1284 36.9013 15.2886 38.0544C14.4488 39.2074 14.7444 40.8533 13.768 40.1422C12.7915 39.431 12.6808 37.9198 13.5206 36.7667C14.3605 35.6136 15.8328 35.2554 16.8092 35.9666Z",
    fill: "#9DA4AF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeepOceanThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeepOceanThumbnail-gray.5239d32892df27cc513fc137356ecda4.svg";